import { BCExtremeGridEntities } from '@bimser/components';
import { DmData, IDmData } from '../../../entities/IDmData';
import { ServiceList } from '../../../services/serviceList';
import { GenerateDmModel } from '../../../utilities/helpers';

const GetTrashItems = async (
	loadOptions: BCExtremeGridEntities.ILoadOptions,
	addToStore: (items: Array<DmData>) => void
) => {
	const { items, totalCount }: { items: Array<IDmData>; totalCount: number } =
		await ServiceList.dm.DocumentManagement.RecycleBin.GetItems.callPromise(
			{ loadOptions },
			true
		);

	if (!items) return { data: [], totalCount: 0 };

	const dmData = items.map(GenerateDmModel);
	addToStore?.(dmData);
	const data: Array<IDmData['metadata']> =
		dmData.map((item: DmData) => ({ ...item.metadata.toJS(), baseItem: item })) || [];

	return { data, totalCount, dmData };
};

export default GetTrashItems;
